export default "__VITE_ASSET__DVjr3P9h__"